import { render, staticRenderFns } from "./Reporte1.vue?vue&type=template&id=a4b6a63a"
import script from "./Reporte1.vue?vue&type=script&lang=js"
export * from "./Reporte1.vue?vue&type=script&lang=js"
import style0 from "./Reporte1.vue?vue&type=style&index=0&id=a4b6a63a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports